<template>
  <div class="geofence-filters">
    <form @submit.prevent="applyFilters(false)">
      <div class="show-mobile">
        <div>
          <a class="button cta xsmall block filter-button" @click="prioritizeGeofences">PRIORITIZE</a>
        </div>

        <div>
          <a class="button cta xsmall block success filter-button" @click="showCreateForm">CREATE GEOFENCE</a>
        </div>
        <a class="button xsmall info filter-btn" @click="isOpenFilter = !isOpenFilter"><i class="fas fa-filter"></i></a>
      </div>

      <div :class="['row filter', isOpenFilter ? 'show' : '']">
        <!--div class="small-4 columns padding-R">
          <div class="filter-field">
            <label>SEARCH GEOFENCES</label>
            <input type="text" placeholder="Type and hit enter to search." v-model="geofenceSearch" />
          </div>
        </div-->

        <div class="small-2 columns padding-R">
          <div class="filter-field">
            <label>FILTER BY TYPE</label>
            <select v-model="geofenceType" @change="applyFilters(true)">
              <option value="airport">Airport</option>
              <option value="staging">Staging</option>
              <option value="restricted">Restricted</option>
              <option value="servicearea">Service Area</option>
              <option value="tracking">Tracking</option>
            </select>
          </div>
        </div>

        <div class="small-2 columns padding-L padding-R">
          <div class="filter-field">
            <label>FILTER BY STATUS</label>
            <select v-model="geofenceStatus" @change="applyFilters(true)">
              <option value="active">Active</option>
              <option value="deactivated">Inactive</option>
              <option value="archived">Archived</option>
            </select>
          </div>
        </div>
        
        <div class="small-2 columns padding-L padding-R">
          <div class="filter-field">
            <label>FILTER BY BRAND</label>
            <select v-model="geofenceBrand" @change="applyFilters(true)" :disabled="isBrand" :class="{'disabled': isBrand}">
              <option value="">Unbranded</option>
              <option v-for="(brand, index) in brands" :key="index" :value="brand.id">{{brand.name}}</option>
            </select>
          </div>
        </div>

        <div class="small-1 columns padding-L">
          <div class="filter-field">
            <label>PAGE</label>
             <select v-model.number="pageNum" @change="applyFilters(false)">
               <option v-for="n in pageTotal" :value="n">{{ n }}</option>
             </select>
          </div>
        </div>

        <div class="small-offset-1 small-2 columns padding-R hide-mobile">
          <a class="button cta xsmall block filter-button" @click="prioritizeGeofences">PRIORITIZE</a>
        </div>

        <div class="small-2 columns padding-L hide-mobile">
          <a class="button cta xsmall block success filter-button" @click="showCreateForm">CREATE GEOFENCE</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ApiBrands from '@/modules/api/brands'
export default {
  name: 'geofence-filters',
  data () {
    return {
      pageNum: 1,
      pageSize: 20,
      pageTotal: 1,
      isBrand: true,
      isOpenFilter: false
      // geofenceType: this.$plugins.storage.getGeofenceByType() || 'airport',
      // geofenceStatus: this.$plugins.storage.getGeofenceByStatus() || 'active',
      // geofenceBrand: this.$plugins.storage.getGeofenceByBrand() || ''
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    // geofenceSearch: {
    //   get () { return this.$store.state.geofences.filters.search },
    //   set (value) { this.$store.commit('geofences/setFilterSearch', value) }
    // },
    geofenceBrand: {
      get () { return this.$store.state.geofences.filters.brands },
      set (value) { this.$store.commit('geofences/setFilterBrands', value) }
    },
    geofenceStatus: {
      get () { return this.$store.state.geofences.filters.status },
      set (value) { this.$store.commit('geofences/setFilterStatus', value) }
    },
    geofenceType: {
      get () { return this.$store.state.geofences.filters.type },
      set (value) { this.$store.commit('geofences/setFilterType', value) }
    },
    _refreshList () { return this.$store.state.geofences.refreshList },
    _priority () { return this.$store.state.geofences.priority.success }
  },
  methods: {
    applyFilters (refresh) {
      let self = this
      self.isOpenFilter = false
      if(self.geofenceType || self.geofenceStatus || self.geofenceBrand) {
        self.$plugins.storage.setGeofenceByType(self.geofenceType)
        self.$plugins.storage.setGeofenceByStatus(self.geofenceStatus)
        self.$plugins.storage.setGeofenceByBrand(self.geofenceBrand)
      }
      let request = {
        token: self.$store.state.session.sessionToken,
        status: self.geofenceStatus,
        pageNum: self.pageNum,
        pageSize: self.pageSize,
        order: 'priority'
      }
        
      if (refresh) { request.pageNum = 1 }
      

      self.$store.commit('geofences/setGeofenceLoading', true)      
      
      if (self.geofenceType === 'servicearea') {
        self.isBrand = false
        request["brandId"] = -1
        if (self.geofenceBrand) {
          request["brandId"] = self.geofenceBrand
        }
        self.$sdk.get('/servicearea', request, r => {
          self.$store.commit('geofences/setGeofenceLoading', false)
          if (r.error) {
            // SHOW ERROR
            return
          }
            
          let result = []
          for (let i = 0; i < r.list.length; i++) {
            let item = r.list[i]
            item['showForm'] = false
            item['isP2P'] = false
            item['type'] = 'servicearea'
            
            result.push(item)
          }
          self.$store.commit('geofences/setGeofenceItems', result)

          self.pageNum = r.paging.pageNum
          let totalPages = Math.ceil(r.paging.totalItems / self.pageSize)
          self.pageTotal = totalPages
        }, '2.0')
        
      } else {
        if (self.geofenceType === 'tracking') {
          self.isBrand = false
          if (self.geofenceBrand) {
            request["brandId"] = self.geofenceBrand
          }
        } else {
          self.isBrand = true
          self.geofenceBrand = ''
        }
        this.$plugins.storage.setGeofenceByBrand('')
        request['type'] = self.geofenceType
        self.$sdk.get('/geofences/search', request, r => {
          self.$store.commit('geofences/setGeofenceLoading', false)
          if (r.error) {
            // SHOW ERROR
            return
          }

          let result = []
          for (let i = 0; i < r.list.length; i++) {
            let item = r.list[i]
            item['showForm'] = false
            item['isP2P'] = false
            if (item.pricing.SharedAirportFee === null) {
              item.pricing.SharedAirportFee = 0
            }
            if (item.pricing.OpoliAirportFee === null) {
              item.pricing.OpoliAirportFee = 0
            }
            if (item.pricing.BlackAirportFee === null) {
              item.pricing.BlackAirportFee = 0
            }
            if (item.pricing.SUVAirportFee === null) {
              item.pricing.SUVAirportFee = 0
            }
            if (item.pricing.PrivateShuttleAirportFee === null) {
              item.pricing.PrivateShuttleAirportFee = 0
            }

            if (typeof item.services === 'undefined' || item.services === null) {
              item['services'] = {
                shared: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
                opoli: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
                black: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
                suv: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
                shuttle: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
              }
            }

            if (self.geofenceType === 'airport') {
              item.uploading = {tnc: false, tcp: false}
              item.formalName = item.formalName || ''
              item.airportPickupTitle = item.pickupInstructions.title || ''
              item.airportPickupInstructionsTNC = item.pickupInstructions.tncText || ''
              item.airportPickupInstructionsTCP = item.pickupInstructions.tcpText || ''
              item.airportPickupImageTNC = item.pickupInstructions.tncImage || ''
              item.airportPickupImageTCP = item.pickupInstructions.tcpImage || ''
              item.airportPickupUpstairs = item.pickupInstructions.upstairsLabel || ''
              item.airportPickupDownstairs = item.pickupInstructions.downstairsLabel || ''
            }

            result.push(item)
          }

          self.$store.commit('geofences/setGeofenceItems', result)

          self.pageNum = r.paging.pageNum
          let totalPages = Math.ceil(r.paging.totalItems / self.pageSize)
          self.pageTotal = totalPages
        })
      }
      
    },
    showCreateForm () { this.$store.commit('geofences/setShowCreateGeofence', true) },
    prioritizeGeofences () { this.$store.commit('geofences/setShowGeofencePriority', true) },
    getBrandsList () {
      let self = this
      self.$store.commit('brands/setLoading', true)
      ApiBrands.getBrands(self, function (res) {
        self.$store.commit('brands/setLoading', false)
      })
    },
    showFilter () {
      console.log('test')
    }
  },
  watch: {
    _refreshList: function (value) {
      if (value) {
        this.$store.commit('geofences/setRefreshList', false)
        this.applyFilters(true)
      }
    },
    _priority: function (value) {
      if (value) {
        this.$store.commit('geofences/setPrioritySuccess', false)
        this.applyFilters(false)
      }
    }
  },
  mounted () {
    if (this.$plugins.storage.getGeofenceByBrand()) {
      this.$store.commit('geofences/setFilterBrands', this.$plugins.storage.getGeofenceByBrand())
    }
    if (this.$plugins.storage.getGeofenceByStatus()) {
      this.$store.commit('geofences/setFilterStatus', this.$plugins.storage.getGeofenceByStatus())
    }
    if (this.$plugins.storage.getGeofenceByType()) {
      this.$store.commit('geofences/setFilterType', this.$plugins.storage.getGeofenceByType())
    }

    this.applyFilters(true)
    this.getBrandsList()
  }
}
</script>

<style lang="scss" scoped>

.geofence-filters {
  margin-bottom: 15px;
  padding: 10px 20px 15px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  position: fixed;
  top: 51px;
  left: 0;
  width: 60%;
  z-index: 4;
  background-color: #F4F8F9;
}
.filter-field {

  & label {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
  }

  & input,
  & select {
    margin-top: 0;
    font-size: 14px;
    padding: 7px 10px;
  }

  & select {
    height: 37px;
    outline: 0;
    display: block;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }

  select:disabled{ background: #eee; }
}

.filter-button { margin-top: 25px; }

.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }

.show-mobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  .geofence-filters {
    width: 100%;
    .padding-L, .padding-R {
      padding: 0;
    }
    .small-2, .small-1 {
      width: 48%;
      margin: 0 1%;
    }
    .small-offset-1 {
      margin: 0;
    }
  }

  .show-mobile {
    display: flex;
    justify-content: space-between;

    div {
      width: 43%;
    }
    .filter-btn {
      background-color: gray;
    }
    .filter-button {
      margin-top: 0;
    }
  }

  .filter {
    display: none;
    &.show {
      display: block;
    }
  }

  .row {
    margin-top: 10px;
  }

  .hide-mobile {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofenceFilters.vue